module.exports = __webpack_public_path__ + "img/result_cert.0cab4db4.svg";